import { useAppSelector } from '../app/hooks/store-hooks';
import useUserRights from './use-user-rights';

export default function useDebugFeatures() {
    const rights = useUserRights();
    const debugFeatures = useAppSelector((state) => state.settings.enableDebugFeatures);

    if (import.meta.env.DEV) {
        return debugFeatures;
    }

    return debugFeatures && rights.showCommandPrototype;
}
